import { formatDate } from "@angular/common";
import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormControl } from "@angular/forms";
import { DateFilterValues } from "apps-module/app/entry-modules/content-search/components/date-filter/date-filter-values.enum";
import { DestroyableMixin } from "apps-module/app/shared-library/mixins/destroyable.mixin";
import { EmptyInstance } from "core-library/mixins/empty-instance";
import { Subscription } from "rxjs";

@Component({
    selector: "[pcg-ng-date-filter]",
    templateUrl: "./date-filter.component.html",
    providers: []
})
export class DateFilterComponent extends DestroyableMixin(EmptyInstance) implements OnInit {
    public readonly DateFilterValues = DateFilterValues;
    public readonly customFromDateControl = new FormControl<string>(null);
    public readonly customToDateControl = new FormControl<string>(null);

    @Input("type")
    public set radioSetter(value: FormControl<DateFilterValues>){
        this.radioControl = value;
    }

    @Input("fromDate")
    public set fromDateSetter(value: FormControl<string>){
        this.fromDateControl = value;
    }

    @Input("toDate")
    public set toDateSetter(value: FormControl<string>){
        this.toDateControl = value;
    }

    public radioControl = new FormControl<DateFilterValues>(DateFilterValues.All);
    public fromDateControl: FormControl<string> = null;
    public toDateControl: FormControl<string> = null;

    @Output()
    public onSubmit = new EventEmitter();

    public onValueChange: Subscription = null;

    public ngOnInit(): void {
        this.onValueChange = this.radioControl.valueChanges.subscribe((value: DateFilterValues) => this.setDateControls(value));

        if (this.radioControl.value === DateFilterValues.Custom) {
            this.customFromDateControl.setValue(this.fromDateControl.value);
            this.customToDateControl.setValue(this.toDateControl.value);
        }

        this.setDateControls(this.radioControl.value);
    }

    public submit(): void {
        if (this.radioControl.value === DateFilterValues.Custom) {
            this.fromDateControl.setValue(this.customFromDateControl.value);
            this.toDateControl.setValue(this.customToDateControl.value);
        }

        this.onSubmit.emit();
    }

    private setDateControls(value: DateFilterValues): void {
        const now = new Date();
        const format = "yyyy-MM-dd";
        const locale = "en";

        switch (value) {
            case DateFilterValues.ThisMonth:
                this.fromDateControl.setValue(formatDate(new Date(now.getFullYear(), now.getMonth(), 1), format, locale));
                this.toDateControl.setValue(formatDate(new Date(now.getFullYear(), now.getMonth() + 1, 0), format, locale));
                break;
            case DateFilterValues.LastMonth:
                this.fromDateControl.setValue(formatDate(new Date(now.getFullYear(), now.getMonth() - 1, 1), format, locale));
                this.toDateControl.setValue(formatDate(new Date(now.getFullYear(), now.getMonth(), 0), format, locale));
                break;
            case DateFilterValues.Last12Month:
                this.fromDateControl.setValue(formatDate(new Date(now.getFullYear() - 1, now.getMonth(), now.getDay()), format, locale));
                this.toDateControl.setValue(formatDate(new Date(now.getFullYear(), now.getMonth(), now.getDay()), format, locale));
                break;
            case DateFilterValues.Custom:
                this.fromDateControl.setValue(this.customFromDateControl.value);
                this.toDateControl.setValue(this.customToDateControl.value);
                break;
            case DateFilterValues.All:
            default:
                this.fromDateControl.reset();
                this.toDateControl.reset();
                break;
        }

        this.customFromDateControl.setValue(this.fromDateControl.value);
        this.customToDateControl.setValue(this.toDateControl.value);
    }
}
